import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {User} from '../classes/user';
import {UserInsight} from '../classes/user-insight';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private apiService: ApiService) {

    }

    getUsers(orderBy?: string, orderDirection?: string, search?: string, skip = 0, limit = 6, roles?: string) {
        let params = {};
        if (orderBy) {
            params = {orderBy, orderDirection};
        }
        if (search) {
            params = {...params, search};
        }
        if (roles) {
            params = {...params, roles};
        }
        return this.apiService.getCall$<User[]>(`users/${limit}/${skip}`, params);
    }

    getAllUsers() {
        return this.apiService.getCall$<User[]>(`users`);
    }

    getManagers() {
        return this.apiService.getCall$<User[]>(`users/managers`);
    }

    deleteUser(userId: number) {
        return this.apiService.deleteCall$(`users/${userId}`);
    }


    getUser(userId: number) {
        return this.apiService.getCall$<User>(`users/${userId}`);
    }

    saveUser(user: User, noErrorDialogs = false, inviteEmail = true) {
        return this.apiService.postCall$<User>('users', {
            ...user,
            inviteEmail
        }, noErrorDialogs);
    }

    updateNotificationPreferences(emailNotifications: boolean) {
        return this.apiService.postCall$<User>('users/notification-preferences', {
            email_ticket_notifications: emailNotifications
        });
    }

    toggleTicketNotifications() {
        return this.apiService.postCall$<User>('users/toggle-ticket-notifications', {});
    }

    getUserInsight(weeks: number = 2) {
        return this.apiService.getCall$<UserInsight[]>(`authorisation-log/post-calls`, { weeks });
    }
}
